export default "__VITE_ASSET__KI71TlvJ__"